import { Component, OnInit, Input } from '@angular/core';


export enum AssetType {
  SVG = 'svg',
  PNG = 'png',
}
@Component({
  selector: 'app-icon-asset',
  template: `
    <img [src]="'../../../assets/images/' + name + extension"
         [ngStyle]="styles"
         (error)="onImageError()"
    />
  `,
  styles: [`
    :host {
        display: inline-block;
    }
  `]
})
export class IconAssetComponent implements OnInit {

  @Input() type: AssetType = AssetType.SVG;
  @Input() width: any;
  @Input() height: any;
  @Input() name: any;
  @Input() alt: any;
  styles = {};
  extension: any;

  constructor() { }

  ngOnInit() {
    this.extension = this.type === AssetType.SVG ? '.svg' : '.png';
    this.generateStyles();
  }

  generateStyles() {
    this.styles = {
      width: this.width ? this.width + 'px' : null,
      height: this.height ? this.height + 'px' : null,
    };
  }

  onImageError() {
    console.error(`${this.name}.svg does not exist`);
    throw Error(`${this.name}.svg does not exist`);
  }

}
